import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, StarIcon } from 'lucide-react';
const buyers = [{
  name: 'Marcela G.',
  city: 'Rosario'
}, {
  name: 'Sofía R.',
  city: 'Mendoza'
}, {
  name: 'Ana B.',
  city: 'Tucumán'
}, {
  name: 'Valentina S.',
  city: 'Salta'
}, {
  name: 'Camila D.',
  city: 'Córdoba'
}, {
  name: 'Florencia M.',
  city: 'La Plata'
}, {
  name: 'Luciana T.',
  city: 'Mar del Plata'
}, {
  name: 'Carolina P.',
  city: 'Santa Fe'
}, {
  name: 'Romina G.',
  city: 'Neuquén'
}, {
  name: 'Daniela V.',
  city: 'Bahía Blanca'
}, {
  name: 'Gabriela H.',
  city: 'San Juan'
}, {
  name: 'Natalia F.',
  city: 'Posadas'
}, {
  name: 'Laura C.',
  city: 'Resistencia'
}, {
  name: 'Alejandra K.',
  city: 'Paraná'
}, {
  name: 'Juan P.',
  city: 'Córdoba'
}, {
  name: 'Diego F.',
  city: 'San Luis'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextPopup();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextPopup = () => {
    const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
    setCurrentBuyer(randomBuyer);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextInterval = Math.floor(Math.random() * (12000 - 8000 + 1) + 8000);
      setTimeout(showNextPopup, nextInterval);
    }, 5000);
  };
  return <AnimatePresence data-id="element-277">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 max-w-sm w-[calc(100%-2rem)] bg-white rounded-xl shadow-2xl border border-gray-100 p-4 flex items-center gap-4" data-id="element-278">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-279">
            <XIcon className="w-4 h-4" data-id="element-280" />
          </button>

          <div className="w-12 h-12 bg-yellow-50 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-281">
            <StarIcon className="w-7 h-7 text-yellow-500 fill-yellow-400" data-id="element-282" />
          </div>

          <div data-id="element-283">
            <p className="text-sm text-gray-800" data-id="element-284">
              <span className="font-bold" data-id="element-285">{currentBuyer.name}</span> de{' '}
              {currentBuyer.city}
            </p>
            <p className="text-xs font-bold text-brand-green mt-1 flex items-center gap-1" data-id="element-286">
              ⭐ Compra verificada
            </p>
            <p className="text-[10px] text-gray-400 mt-1" data-id="element-287">Hace unos minutos</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}